import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReadListComponent } from './read-list.component';
import { ReadListGuard } from './read-list.guard';
import { ReadListResolve } from './read-list.resolve';

const routes: Routes = [
  { path: ':group_id/:board_type/:letter_id', canActivate:[ReadListGuard], resolve:{data:ReadListResolve}, component:ReadListComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReadListRoutingModule { }
